import gql from 'graphql-tag'

export const getPosterQuery = gql`
    query getPoster($eventId: EventID!, $filters: PosterSpaceFilter) {
        event(id: $eventId) {
            posterSpaces(filters: $filters) {
                edges {
                    node {
                        id
                        enableVideo
                        enableMessaging
                        posterSorting
                        parent {
                            name
                            image
                            helpContent
                            helpContentType
                            published
                            enableChat
                        }
                    }
                }
            }
        }
    }
`

const posterItem = gql`
    fragment posterItem on PosterType {
        id
        pdf
        preview
        authorNames
        title
        abstract
        videoUrl
        enableChat
        author {
            email
            hasLoggedOn
        }
        locationType
    }
`

export const getPosterListQuery = gql`
    query getPosterList($eventId: EventID!, $filters: PosterSpaceFilter, $search: String, $first: Int, $after: ID, $sort: PosterOrder) {
        event(id: $eventId) {
            posterSpaces(filters: $filters) {
                edges {
                    node {
                        id
                        posters(search: $search, orderBy: $sort, after: $after, first: $first) {
                            edges {
                                node {
                                    ...posterItem
                                }
                            }
                            pageInfo {
                                hasPreviousPage
                                hasNextPage
                                endCursor
                            }
                            totalCount
                        }
                    }
                }
            }
        }
    }
    ${posterItem}
`
